import { useEffect, useState } from "react";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";
import { ActorTransform } from "../../../types";
import { useEditorSelector } from "../../../hooks/redux";
import { STAGE_CELL_SIZE } from "../../constants/constants";
import ActorSprite from "../sprites/actor-sprite";
import { TransformLabels } from "./transform-images";
import { RELATIVE_TRANSFORMS } from "./transform-lookup";

export const TransformEditorModal = ({
  open,
  value,
  onChange,
  characterId,
  appearance,
}: {
  open: boolean;
  value: ActorTransform;
  characterId?: string;
  appearance?: string;
  onChange: (value: ActorTransform) => void;
}) => {
  const characters = useEditorSelector((e) => e.characters);
  const [transform, setTransform] = useState<ActorTransform>(value);

  useEffect(() => {
    setTransform(value);
  }, [open, value]);

  return (
    <Modal
      isOpen={open}
      backdrop="static"
      toggle={() => {}}
      style={{ maxWidth: 700, minWidth: 700 }}
    >
      <div className="modal-header" style={{ display: "flex" }}>
        <h4 style={{ flex: 1 }}>Choose Direction</h4>
      </div>
      <ModalBody>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 8,
            marginBottom: 16,
            justifyContent: "center",
          }}
        >
          <Button onClick={() => setTransform("0")}>Reset</Button>
          <Button onClick={() => setTransform(RELATIVE_TRANSFORMS[transform]["270"])}>
            Rotate -90º
          </Button>
          <Button onClick={() => setTransform(RELATIVE_TRANSFORMS[transform]["90"])}>
            Rotate 90º
          </Button>
          <Button onClick={() => setTransform(RELATIVE_TRANSFORMS[transform]["flip-x"])}>
            Flip Horizontally
          </Button>
          <Button onClick={() => setTransform(RELATIVE_TRANSFORMS[transform]["flip-y"])}>
            Flip Vertically
          </Button>
        </div>
        <div
          style={{
            position: "relative",
            width: 7 * STAGE_CELL_SIZE,
            height: 7 * STAGE_CELL_SIZE,
            border: "2px solid #ccc",
            margin: "auto",
            zoom: 1.2,
            background: `url('${new URL("../../img/board-grid.png", import.meta.url).href}') top left / ${STAGE_CELL_SIZE}px`,
          }}
        >
          {characterId && appearance && (
            <ActorSprite
              character={characters[characterId]}
              actor={{
                id: "0",
                variableValues: {},
                position: { x: 4, y: 4 },
                appearance,
                transform,
                characterId,
              }}
            />
          )}
          <div
            style={{
              width: STAGE_CELL_SIZE,
              height: STAGE_CELL_SIZE,
              border: `2px solid red`,
              outline: "1px solid white",
              left: "50%",
              top: "50%",
              zIndex: 2,
              position: "absolute",
              transform: `translate(-${STAGE_CELL_SIZE / 2}px,-${STAGE_CELL_SIZE / 2}px)`,
            }}
          />
        </div>
        <div style={{ textAlign: "center" }}>
          <strong>{TransformLabels[transform]}</strong>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button onClick={() => onChange(value)}>Cancel</Button>{" "}
        <Button data-tutorial-id="keypicker-done" onClick={() => onChange(transform)}>
          Done
        </Button>
      </ModalFooter>
    </Modal>
  );
};
